import React from "react";

import { Link } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { Navbar, Nav, NavItem, MenuItem } from "react-bootstrap";

import logo from "../../../images/logo.png";
import Utils from "../../../lib/utils";
import { styles, StyledNavbar, Logo, Container, Dropdown } from "./style.ts";

const TopBar = ({ logOut, DropdownButton, showDiscordModal, user }) => (
  <Container>
    <StyledNavbar style={styles.container} fixedTop className="header">
      <Logo>
        <Navbar.Header>
          <Navbar.Brand>
            <Link style={styles.logo} to="/">
              <img src={logo} alt="QuirkyCoders" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle id="nav-toggle" style={styles.toggle} />
        </Navbar.Header>
      </Logo>
      <Navbar.Collapse>
        <Nav>
          {Utils.isSignedIn() && (
            <LinkContainer to="/dashboard">
              <NavItem style={styles.link}>Dashboard</NavItem>
            </LinkContainer>
          )}
          {(!Utils.isSignedIn() || Utils.isApplicant(user)) && (
            <LinkContainer to="/jobs">
              <NavItem style={styles.link}>
                <i className="fa fa-search" alt="search" /> Search
              </NavItem>
            </LinkContainer>
          )}
        </Nav>
        <a
          href="/#"
          rel="noopener noreferrer"
          style={styles.link}
          onClick={showDiscordModal}
        >
          Community
        </a>
        {Utils.isSignedIn() && Utils.isEmployer(user) && user.id === 11 && (
          <Nav>
            <LinkContainer to="/admin/analytics">
              <NavItem style={styles.link}>Analytics</NavItem>
            </LinkContainer>
          </Nav>
        )}
        <Nav pullRight>
          {!Utils.isSignedIn() && (
            <LinkContainer to="/login">
              <NavItem style={styles.link}>Signin / Register</NavItem>
            </LinkContainer>
          )}
          {!Utils.isSignedIn() && (
            <LinkContainer to="/employers">
              <NavItem style={styles.link}>Post Jobs / Employers</NavItem>
            </LinkContainer>
          )}
          {Utils.isSignedIn() && Utils.isApplicant(user) && (
            <Dropdown id="dropdown" title={DropdownButton(user)}>
              <LinkContainer to="/dashboard/profiles">
                <MenuItem>Profile</MenuItem>
              </LinkContainer>
              <LinkContainer to="/dashboard/jobs">
                <MenuItem>Jobs</MenuItem>
              </LinkContainer>
              <LinkContainer to="/dashboard/resumes">
                <MenuItem>Resumes</MenuItem>
              </LinkContainer>
              {false && (
                <LinkContainer to="/dashboard/alerts">
                  <MenuItem>Alerts</MenuItem>
                </LinkContainer>
              )}
              {false && (
                <LinkContainer to="/dashboard/settings">
                  <MenuItem>Settings</MenuItem>
                </LinkContainer>
              )}
              <MenuItem onClick={logOut}>Logout</MenuItem>
            </Dropdown>
          )}
          {Utils.isSignedIn() && Utils.isEmployer(user) && (
            <Dropdown id="dropdown" title={DropdownButton(user)}>
              <LinkContainer to="/dashboard/jobs">
                <MenuItem>Jobs</MenuItem>
              </LinkContainer>
              {false && (
                <LinkContainer to="/dashboard/alerts">
                  <MenuItem>Alerts</MenuItem>
                </LinkContainer>
              )}
              {false && (
                <LinkContainer to="/dashboard/settings">
                  <MenuItem>Settings</MenuItem>
                </LinkContainer>
              )}
              <MenuItem onClick={logOut}>Logout</MenuItem>
            </Dropdown>
          )}
        </Nav>
      </Navbar.Collapse>
    </StyledNavbar>
  </Container>
);

export default TopBar;
